module.exports = __webpack_public_path__ + "img/selected3-min.4f6d08f7.png";